import React, { useState } from 'react';
import { getFormValues, reduxForm } from 'redux-form';
import { __ } from '../../core/utils';
import styles from '../../styles/forms/plans/EditWorkingSetPlanToolbarForm.scss';
import Select from '../../components/Select';
import Tooltip from '../../components/Tooltip';
import classNames from 'classnames';
import connect from 'react-redux/es/connect/connect';
import * as _ from 'lodash';
import { subscribe } from 'react-contextual/dist/react-contextual.es';
import Localization from '../../helpers/Localization';

// ICONS
import MeetingStatusIcon from '../../assets/images/meeting-status-15x15.svg';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import PlanChildIcon from '../../assets/images/plan-child.svg';
import PlanParentIcon from '../../assets/images/plan-parent.svg';
import PlanSingleIcon from '../../assets/images/plan-single.svg';

const EditCurrentSetPlanToolbarForm = (props) => {
  const [status_switcher, set_status_switcher] = useState(false);
  const [type_switcher, set_type_switcher] = useState(false);

  const { data, values } = props;
  const { status, type } = values;

  const statuses = [
    {
      value: '1',
      label: __('current_set_plan.status.active'),
      color: '#5777FC',
      disabled: !_.includes(['1'], status),
    },

    {
      value: '0',
      label: __('current_set_plan.status.canceled'),
      color: '#CCCDD1',
      disabled: !_.includes(['1'], status),
    },
  ];

  const types = [
    {
      value: 'single',
      label: __('current_set_plan.type.single'),
      color: '#9C27B0',
      icon: <PlanSingleIcon className={styles.icon} />,
    },

    {
      value: 'parent',
      label: __('current_set_plan.type.parent'),
      color: '#5777FC',
      icon: <PlanParentIcon className={styles.icon} />,
    },

    {
      value: 'child',
      label: __('current_set_plan.type.child'),
      color: '#ADD42B',
      icon: <PlanChildIcon className={styles.icon} />,
    },
  ];

  const disabled = true;

  return (
    <div className={styles.wrapper}>
      <Select
        disabled={disabled}
        input={{
          value: status,

          onChange: (value) => {
            if (value === status) return;

            if (_.includes(['0'], value))
              showAlertbox({
                color: 'red',
                title: __('general.alert.are-you-sure'),
                description: `${__(
                  `working_set_plans.working-set-plan-status.first-warning`
                )}\n\n${__(
                  `working_set_plans.working-set-plan-status.second-warning`
                )}`,
                buttons: [
                  {
                    color: 'lightGray',
                    text: __('general.alert.no-close'),
                    onClick: 'close',
                  },
                  {
                    color: 'gray',
                    text: __('general.alert.yes-change-status'),
                    onClick: () => {
                      props.onSubmit({ status: value, id: data.id });

                      hideAlertbox();
                    },
                  },
                ],
              });
            else {
              // hideAlertbox();
            }
          },
          onBlur: () => set_status_switcher(false),

          onFocus: () => set_status_switcher(true),
        }}
        meta={{
          active: status_switcher,
        }}
        label={__('Status')}
        options={statuses}
        noSort
        dropdown
        top={34}
        icon={<MeetingStatusIcon className={styles.icon} />}
        wrapper={(handleOpen, activeItem) => (
          <Tooltip text={__('working-set-plans.status.tooltip.icon')}>
            <div
              className={classNames(
                styles.dropdown,
                disabled && styles.disabled
              )}
              style={{ background: activeItem.color }}
              onClick={handleOpen}
            >
              <MeetingStatusIcon className={styles.icon} />
              <div className={styles.button}>
                {activeItem.label}
                <ArrowDownSmallIcon />
              </div>
            </div>
          </Tooltip>
        )}
      />

      <Select
        disabled={disabled}
        input={{
          value: type,

          onChange: (value) => {
            if (value === type) return;

            props.onSubmit({ type: value, id: data.id, status });
          },
          onBlur: () => set_type_switcher(false),

          onFocus: () => set_type_switcher(true),
        }}
        meta={{
          active: type_switcher,
        }}
        label={__('Type')}
        options={types}
        noSort
        dropdown
        top={34}
        icon={<MeetingStatusIcon className={styles.icon} />}
        wrapper={(handleOpen, activeItem) => (
          <Tooltip text={__('current-set-plans.type.tooltip.icon')}>
            <div
              className={classNames(
                styles.dropdown,
                disabled && styles.disabled
              )}
              style={{ background: activeItem.color }}
              onClick={handleOpen}
            >
              {activeItem.icon}
              <div className={styles.button}>
                {activeItem.label}
                <ArrowDownSmallIcon />
              </div>
            </div>
          </Tooltip>
        )}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user_id: state.auth.id,
    values: getFormValues('plans.edit_current_set_plan_toolbar')(state),
  };
};

export default reduxForm({
  form: 'plans.edit_current_set_plan_toolbar',
  enableReinitialize: true,
})(
  connect(
    mapStateToProps,
    null
  )(subscribe(Localization, 'localization')(EditCurrentSetPlanToolbarForm))
);
